import React, { Fragment, useEffect, useRef, useState } from 'react'
import autosize from "autosize/dist/autosize"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  CircleExclamationSolidIcon, EditIcon
} from '@csrc/assets/icons'

import TextArea from "./TextArea"
import '../../assets/scss/content-editable.scss'
import ConditionalRendering from "@src/components/ConditionalRendering"

const ContentEditable = (props) => {
  const {
    id,
    name,
    onBlur = () => { },
    rules = {},
    _onFocus = () => { },
    defaultValue,
    placeholder,
    className,
    style,
    hasIcon,
    popUpInfo,
    icon,
    disabled,
    enableEditFromInit,
    html = false,
    editText = false,
    ignoreFirstBlur = false,
    textAreaProps = {}
  } = props
  const [value, setValueState] = useState(defaultValue)
  // const [rows, setRows] = useState(_.size(_.split(defaultValue, '\n')))
  const [editable, setEditable] = useState(enableEditFromInit || (editText))
  const [init, setInit] = useState(true)
  const newRef = useRef()
  const { unregister, setValue, register } = props.formMethods

  useEffect(() => {
    setValueState(defaultValue)
    // setRows(_.size(_.split(defaultValue, '\n')))
  }, [defaultValue])

  useEffect(() => {
    register(name, rules)
    setValue(name, defaultValue)
    autosize(newRef)
    return () => {
      unregister(name)
    }
  }, [])

  const _onStateEdit = (e) => {
    setValueState(e.target.value)
    setValue(props.name, e.target.value)
    // setRows(_.size(_.split(e.target.value, '\n')))
  }

  const _onSave = (e) => {
    if (!editText) {
      setEditable(false)
    }
    if (e.target.value !== defaultValue && !(e.target.value === '' && defaultValue === null)) {
      onBlur(e.target)
      _onStateEdit(e)
    }
  }
  const styles = {
    position: 'relative',
    fontSize: '1rem',
    lineHeight: '2rem',
    width: '100%',
    maxWidth: '100%',
    background: 'transparent',
    margin: 0,
    border: '2px transparent solid',
    minHeight: 40,
    ...style
  }
  const renderSpanItem = (x) => {
    return x.length > 0 ? <span>{x}</span> : <span>&nbsp;</span>
  }

  useEffect(() => {
    if (disabled) {
      setEditable(false)
    }
  }, [disabled])

  const popUpIcon = popUpInfo ? (
    <div onClick={popUpInfo} className={'d-flex justify-content-center align-items-center'}
      style={{ position: 'absolute', top: 0, right: 5, height: '100%', zIndex: 0 }}>
      {
        icon ?? <FontAwesomeIcon style={{ fontSize: 12 }} icon={CircleExclamationSolidIcon} color={'#aaa'} />
      }
    </div>
  ) : null

  return (
    <>
      {
        html ? (
          <div>
            <div
              style={{ minHeight: 40 }}
              className={`_1EEDX _ygkSb ${className}`}
              dangerouslySetInnerHTML={{ __html: value }}
            >
            </div>
            <ConditionalRendering shouldRender={!editable}>
              {popUpIcon}
            </ConditionalRendering>
          </div>
        ) : (
          (editable && !disabled) ? (
            <>
              <TextArea
                className={`text-area ${className}`}
                style={styles}
                defaultValue={value}
                disabled={disabled}
                onBlur={_onSave}
                onFocus={_onFocus}
                ignoreFirstBlur={ignoreFirstBlur}
                init={init}
                setInit={setInit}
                {...textAreaProps}
              />
              {/* <ConditionalRendering shouldRender={!editable}> */}
              {popUpIcon}
              {/* </ConditionalRendering> */}
            </>
          ) : (
            <div
              className={`_1EEDX _ygkSb ${className} ${disabled ? 'bg-light' : ''}`}
              style={styles}
              onClick={() => {
                if (!disabled && !editText) {
                  setEditable(true)
                }
              }}
              id={id ?? undefined}
            >
              {
                value && value.length > 0 && value.indexOf('\n') > -1 ? value.split('\n').map((x, i) => {
                  return (
                    i > 0 ? <Fragment key={i}>
                      <br />
                      {renderSpanItem(x, i)}
                    </Fragment> : <Fragment key={i}>
                      {renderSpanItem(x, i)}
                    </Fragment>
                  )
                }) : (value && value.length > 0 ? <span>{value}</span> : <span className={'text-muted'}>{placeholder}</span>)
              }
              {(hasIcon && !disabled) && <>&nbsp;&nbsp;<FontAwesomeIcon style={{ fontSize: 12 }} icon={EditIcon} color={'#aaa'} /></>}
              <ConditionalRendering shouldRender={!editable}>
                {popUpIcon}
              </ConditionalRendering>
            </div>
          )
        )
      }
    </>
  )
}

ContentEditable.propTypes = {

}

export default ContentEditable
